"use client";

import React from "react";
const stats = [{
  value: "25+",
  label: "Years of Experience"
}, {
  value: "100+",
  label: "Luxury Projects"
}, {
  value: "100%",
  label: "Client Satisfaction"
}];
const testimonial = {
  quote: "God Father Company transformed our vision into reality with unmatched precision and elegance. Miguel and his team are true masters of their craft, delivering a home that exceeded every expectation.",
  author: "Sarah & James T.",
  location: "Westlake Hills, Austin"
};
export default function ProvenResults() {
  return <section id="proven-results" className="w-full py-24 lg:py-32 bg-background text-foreground overflow-hidden">
      <div className="container mx-auto px-4 md:px-8 max-w-7xl">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24 items-center">
          
          {}
          <div className="flex flex-col gap-12">
            <div>
              <h2 className="font-default text-4xl md:text-5xl font-bold uppercase tracking-wide text-primary">
                Proven Results
              </h2>
              <h3 className="font-default text-sm md:text-base font-medium uppercase tracking-wide mt-4 text-muted-foreground">
                Consistently Honored Among Austin's Premier Builders
              </h3>
            </div>

            <div className="border-l-2 border-primary pl-6 py-2">
              <p className="text-lg md:text-xl italic leading-relaxed text-foreground/90">"We are extremely happy with their work and already have a few more jobs pending with them over the next week or so. They will be the first contractors we contact anytime we need work done in the future. Highly recommend God Father Company for quality home repair and renovation work."</p>
              <div className="mt-6">
                <p className="font-default font-semibold uppercase text-sm tracking-wide">S Miller</p>
                <p className="text-xs text-muted-foreground uppercase tracking-wider mt-1">Austin, TEXAS</p>
              </div>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-3 gap-8 pt-8 border-t border-border/20">
              {stats.map((stat, i) => <div key={i} data-index={i} className="flex flex-col">
                  <span className="font-default text-5xl md:text-6xl font-bold text-primary">
                    {stat.value}
                  </span>
                  <span className="text-xs md:text-sm uppercase tracking-wider mt-3 text-muted-foreground font-medium">
                    {stat.label}
                  </span>
                </div>)}
            </div>
          </div>

          {}
          <div className="relative h-[500px] lg:h-[700px] w-full">
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681426/img/proven_results_main_exterior.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681426/img/proven_results_main_exterior.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681426/img/proven_results_main_exterior.png-wvc-srcset" alt="Luxury Custom Home Exterior in Austin" className="absolute top-0 right-0 w-[85%] h-[80%] object-cover shadow-lg" loading="lazy" />
            <img data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681426/img/proven_results_secondary_interior.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681426/img/proven_results_secondary_interior.png-wvc-sizes" alt="High-end Kitchen Remodel" className="absolute bottom-0 left-0 w-[65%] object-cover border-8 border-background shadow-2xl !h-[450px]" loading="lazy" src="https://gfccontractors.com/wp-content/uploads/2026/09/TECPRJ5590.jpg" />
          </div>

        </div>
      </div>
    </section>;
}